import React from 'react';
import { OrderCallFormAndIcon } from '../molecules/OrderCallFormAndIcon';
import { FeaturesGroup } from '../molecules/FeaturesGroup';
import { NumbersGroup } from '../molecules/NumbersGroup';
import { AutomationGroup } from '../molecules/AutomationGroup';
import { FeedbackGroup } from '../molecules/FeedbackGroup';
import { useSeo } from '../../../common/hooks/useSeo';
import { pathMain } from '../../../common/config/paths';

interface ISectionAutomation {
  hash: string
}


export const SectionAutomation = ({hash}: ISectionAutomation) => {
  useSeo({
    title: "ООО АБС — автоматизация бизнеса и разработка на 1С",
    description:
      "IT-компания «АБС» — современные программные решения на базе 1С для эффективного управления бизнесом. Разработка, внедрение и сопровождение с 2002 года.",
    canonicalPath: pathMain,
  })

  return (
    <section>
     <OrderCallFormAndIcon />
     <FeaturesGroup />
     <NumbersGroup />
     <AutomationGroup hash={hash}/>
     <FeedbackGroup  hash={hash}/>
    </section>
  );
}
